import script from "./ProportionSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProportionSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ProportionSelector.vue?vue&type=style&index=0&id=4204a080&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4204a080"]])

export default __exports__